import type { ModalDialogProps } from '@atlaskit/modal-dialog/types';
import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint, LoadableLazy } from '@confluence/loadable';

export const DevToolsDialog: LoadableType<
	Pick<ModalDialogProps, 'onClose' | 'onCloseComplete'> & {
		onCloseHelpPanel?: () => void;
	}
> = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-DevToolsDialog" */ './DevToolsDialog.tsx'))
			.DevToolsDialog,
});

export const LazyDevToolsDialog: LoadableType<
	Pick<ModalDialogProps, 'onClose' | 'onCloseComplete'> & {
		onCloseHelpPanel?: () => void;
	}
> = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-DevToolsDialog" */ './DevToolsDialog.tsx'))
			.DevToolsDialog,
});

export const DevToolsBanner: LoadableType<{}> = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-DevToolsBanner" */ './DevToolsBanner.tsx'))
			.DevToolsBanner,
});
